import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Final Payments & Deductions\n          "),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "text-gray-700 italic" }, "* If there are no further leaver payments please click save at the bottom of the page")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h4", { class: "text-blue-700" }, "Purchased Annual Leave:", -1);
const _hoisted_5 = { class: "mt-2" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "additional_leave",
    class: "block text-sm font-medium text-gray-700"
}, "Please provide the number of days additional leave purchased:", -1);
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "mt-2" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", {
    for: "current_leave",
    class: "block text-sm font-medium text-gray-700"
}, "\n                Please provide the number of days additional purchased leave which has been taken for the current leave year:\n              ", -1);
const _hoisted_10 = ["disabled"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "Please note any outstanding balance will be recovered from the employees final pay. If there is not a sufficient\n            amount a communication will be issued to advise on how to pay the remaining balance.\n            ", -1);
const _hoisted_12 = { class: "mt-2" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments_leave",
    class: "block text-sm font-medium text-gray-700"
}, "\n                Comments re purchased annual leave:\n              ", -1);
const _hoisted_14 = ["disabled"];
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "Please note any comments related to the employees purchased annual leave which you would like to share with\n            the SSC Leavers Team", -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("h4", { class: "text-blue-700" }, "Pay in Lieu of Notice/Settlements:", -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "If you are awaiting final signatures / figures, please do not include the payment information here as, if provided, the team\n                will process the information via Payroll when it may not be right to do so.\n                Once finalised, the final payment information should be emailed separately to the ssc-hiretoretire.uk@equans.com email\n                address, along with HR approval, and the team will process directly from your email instruction.\n            ", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "*Please Note: An employee is entitled to a maximum of £30,000 tax free for redundancy/settlement agreements and\n                anything above this value must be subject to tax and national insurance.\n            ", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "Please bear in mind that the employee may have loans in place that may need to be retrieved from their final salary. If you\n                are unsure, please check with your HR Manager.\n            ", -1);
const _hoisted_20 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", {
    for: "in_lieu",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Pay in lieu of notice (taxable and subject to NI):", -1);
const _hoisted_22 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_23 = ["disabled"];
const _hoisted_24 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", {
    for: "redundancy_pay",
    class: "block text-sm font-medium text-gray-700"
}, "Redundancy pay (non-taxable):", -1);
const _hoisted_26 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_27 = ["disabled"];
const _hoisted_28 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", {
    for: "redundancy_pay_ni",
    class: "block text-sm font-medium text-gray-700"
}, "Redundancy pay (taxable and subject to NI):", -1);
const _hoisted_30 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("label", {
    for: "settlement_pay",
    class: "block text-sm font-medium text-gray-700"
}, "Compromise/Settlement pay (non-taxable):", -1);
const _hoisted_34 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_35 = ["disabled"];
const _hoisted_36 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("label", {
    for: "settlement_pay_ni",
    class: "block text-sm font-medium text-gray-700"
}, "Compromise/Settlement pay (taxable and subject to NI):", -1);
const _hoisted_38 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_39 = ["disabled"];
const _hoisted_40 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("label", {
    for: "ex_gratia",
    class: "block text-sm font-medium text-gray-700"
}, "Ex-Gratia (non-taxable):", -1);
const _hoisted_42 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_43 = ["disabled"];
const _hoisted_44 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", {
    for: "ex_gratia_ni",
    class: "block text-sm font-medium text-gray-700"
}, "Ex-Gratia (taxable and subject to NI):", -1);
const _hoisted_46 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_47 = ["disabled"];
const _hoisted_48 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("label", {
    for: "consideration_payment",
    class: "block text-sm font-medium text-gray-700"
}, "Consideration payment (taxable and subject to NI):", -1);
const _hoisted_50 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_51 = ["disabled"];
const _hoisted_52 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("label", {
    for: "pension_fund",
    class: "block text-sm font-medium text-gray-700"
}, "Payment to be made to the Employee's Pension Fund:", -1);
const _hoisted_54 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_55 = ["disabled"];
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-blue-700" }, "Please provide details of any further deductions/payments to final day:", -1);
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, "For example money that needs to be deducted for training fees if the employee is leaving during the qualifying\n                period or repayment of any licence fee's due (i.e. SIA licence fees).\n            ", -1);
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("label", {
    class: "block text-sm font-medium text-gray-700",
    for: "deduction_payment"
}, "Is this a deduction or a payment?", -1);
const _hoisted_59 = ["disabled", "value"];
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    selected: "",
    disabled: ""
}, null, -1);
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("option", { value: "Deduction" }, "Deduction", -1);
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("option", { value: "Payment" }, "Payment", -1);
const _hoisted_63 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_64 = /*#__PURE__*/ _createElementVNode("label", {
    for: "reason_deduction",
    class: "block text-sm font-medium text-gray-700"
}, "Reason for deduction/payment:", -1);
const _hoisted_65 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_66 = ["disabled"];
const _hoisted_67 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_68 = /*#__PURE__*/ _createElementVNode("label", {
    for: "value_deduction",
    class: "block text-sm font-medium text-gray-700"
}, "Value of deduction/payment:", -1);
const _hoisted_69 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_70 = ["disabled"];
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm test-red-700" }, "All payments quoted in the Compromise/Settlement Agreement should be quoted clearly in the Leaver Form sections\n                above.\n            ", -1);
const _hoisted_72 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm test-red-700" }, "Please note, the Employee Services Team will process any payments recorded below in the next available payroll.", -1);
const _hoisted_73 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm test-red-700" }, "If the payment needs to be made in advance of the next available payroll via Manual Payment, please provide the date by\n                which payment needs to be made in the box below.\n            ", -1);
const _hoisted_74 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("label", {
    for: "date_of_payment",
    class: "block text-sm font-medium text-gray-700"
}, "Date of payment", -1);
const _hoisted_76 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_77 = ["disabled"];
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm test-red-700" }, "Please submit the Manual Payment Request to Payroll attaching the usual approvals.", -1);
const _hoisted_79 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_80 = { key: 0 };
const _hoisted_81 = { key: 1 };
const _hoisted_82 = { key: 0 };
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("p", { class: "italic text-sm text-gray-700" }, "* If you do not need to add an approver, please click the reset form button at the bottom of the form.", -1);
const _hoisted_84 = {
    key: 1,
    class: "flex"
};
const _hoisted_85 = ["value"];
const _hoisted_86 = ["disabled"];
import { CheckIcon, XIcon } from '@heroicons/vue/solid';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ModalWindow from '@/components/ModalWindow.vue';
import UserSearch from '@/components/userDropdownSearch.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'formNine',
    props: {
        disableForm: { type: Boolean, default: false },
        configItems: { default: () => ({}) }
    },
    emits: ["submit-form", "submit-leaver"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const router = useRouter();
        const formData = computed(() => store.getters['leaverForm/getLeaverFormData']('formNine'));
        const showUserSearch = computed(() => Boolean(Object.keys(formData.value).find((key) => formData.value[key] && key !== 'saved')));
        const showModal = ref(false);
        const openModal = () => {
            showModal.value = true;
        };
        const closeModal = () => {
            showModal.value = false;
        };
        const handleUser = (event) => {
            const assigneeUserId = event.userID ?? event.id;
            const email = event.email ?? '';
            if (assigneeUserId) {
                formData.value.HROpsAssignee = { userID: assigneeUserId, email };
            }
            else {
                formData.value.HROpsAssignee = undefined;
            }
        };
        const clearUser = () => {
            formData.value.HROpsAssignee = undefined;
        };
        const handleInput = (event) => {
            const target = event.target;
            const { name, value } = target;
            formData.value[name] = value;
        };
        const clearForm = () => {
            store.dispatch('leaverForm/setLeaverFormState', {
                formName: 'formNine',
                formData: {
                    additional_leave: '',
                    current_leave: '',
                    comments_leave: '',
                    in_lieu: '',
                    redundancy_pay: '',
                    redundancy_pay_ni: '',
                    settlement_pay: '',
                    settlement_pay_ni: '',
                    consideration_payment: '',
                    pension_fund: '',
                    reason_deduction: '',
                    value_deduction: '',
                    date_of_payment: '',
                },
            });
        };
        const handleSave = async () => {
            openModal();
        };
        const submitForm = () => {
            emit('submit-form', { name: 'formNine', formData: formData.value });
            router.push('/');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("form", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createTextVNode(),
                            _hoisted_4,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "additional_leave-input",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.value.additional_leave) = $event)),
                                    type: "number",
                                    min: "0",
                                    name: "additional_leave",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", { 'bg-gray-200 border-none cursor-not-allowed': props.disableForm }]),
                                    disabled: props.disableForm
                                }, null, 10, _hoisted_7), [
                                    [_vModelText, formData.value.additional_leave]
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "current_leave-input",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.value.current_leave) = $event)),
                                    type: "number",
                                    min: "0",
                                    name: "current_leave",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", { 'bg-gray-200 border-none cursor-not-allowed': props.disableForm }]),
                                    disabled: props.disableForm
                                }, null, 10, _hoisted_10), [
                                    [_vModelText, formData.value.current_leave]
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_11,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("textarea", {
                                    id: "comments_leave-input",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.value.comments_leave) = $event)),
                                    name: "comments_leave",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", { 'bg-gray-200 border-none cursor-not-allowed': props.disableForm }]),
                                    disabled: props.disableForm
                                }, null, 10, _hoisted_14), [
                                    [_vModelText, formData.value.comments_leave]
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_15,
                            _createTextVNode(),
                            _hoisted_16,
                            _createTextVNode(),
                            _hoisted_17,
                            _createTextVNode(),
                            _hoisted_18,
                            _createTextVNode(),
                            _hoisted_19,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_22, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "in_lieu-input",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((formData.value.in_lieu) = $event)),
                                        type: "text",
                                        name: "in_lieu",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_23), [
                                        [_vModelText, formData.value.in_lieu]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_26, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "redundancy_pay-input",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((formData.value.redundancy_pay) = $event)),
                                        type: "text",
                                        name: "redundancy_pay",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_27), [
                                        [_vModelText, formData.value.redundancy_pay]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_30, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "redundancy_pay_ni-input",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formData.value.redundancy_pay_ni) = $event)),
                                        type: "text",
                                        name: "redundancy_pay_ni",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_31), [
                                        [_vModelText, formData.value.redundancy_pay_ni]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_34, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "settlement_pay-input",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((formData.value.settlement_pay) = $event)),
                                        type: "text",
                                        name: "settlement_pay",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_35), [
                                        [_vModelText, formData.value.settlement_pay]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_36, [
                                _hoisted_37,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_38, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "settlement_pay_ni-input",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((formData.value.settlement_pay_ni) = $event)),
                                        type: "text",
                                        name: "settlement_pay_ni",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_39), [
                                        [_vModelText, formData.value.settlement_pay_ni]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_42, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "ex_gratia-input",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formData.value.ex_gratia) = $event)),
                                        type: "text",
                                        name: "ex_gratia",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_43), [
                                        [_vModelText, formData.value.ex_gratia]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_46, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "ex_gratia_ni-input",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((formData.value.ex_gratia_ni) = $event)),
                                        type: "text",
                                        name: "ex_gratia_ni",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_47), [
                                        [_vModelText, formData.value.ex_gratia_ni]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_48, [
                                _hoisted_49,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_50, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "consideration_payment-input",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((formData.value.consideration_payment) = $event)),
                                        type: "text",
                                        name: "consideration_payment",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_51), [
                                        [_vModelText, formData.value.consideration_payment]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_54, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "pension_fund-input",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((formData.value.pension_fund) = $event)),
                                        type: "text",
                                        name: "pension_fund",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_55), [
                                        [_vModelText, formData.value.pension_fund]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_56,
                            _createTextVNode(),
                            _hoisted_57,
                            _createTextVNode(),
                            _createElementVNode("div", null, [
                                _hoisted_58,
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    id: "deduction_payment-select",
                                    disabled: props.disableForm,
                                    value: formData.value?.deduction_payment,
                                    name: "deduction_payment",
                                    class: "w-full mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed disabled:border-none",
                                    onChange: handleInput
                                }, [
                                    _hoisted_60,
                                    _createTextVNode(),
                                    _hoisted_61,
                                    _createTextVNode(),
                                    _hoisted_62
                                ], 40, _hoisted_59)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_63, [
                                _hoisted_64,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_65, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "reason_deduction-input",
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((formData.value.reason_deduction) = $event)),
                                        type: "text",
                                        name: "reason_deduction",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_66), [
                                        [_vModelText, formData.value.reason_deduction]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_69, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "value_deduction-input",
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((formData.value.value_deduction) = $event)),
                                        type: "text",
                                        name: "value_deduction",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_70), [
                                        [_vModelText, formData.value.value_deduction]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_71,
                            _createTextVNode(),
                            _hoisted_72,
                            _createTextVNode(),
                            _hoisted_73,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_74, [
                                _hoisted_75,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_76, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "date_of_payment-input",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((formData.value.date_of_payment) = $event)),
                                        type: "date",
                                        name: "date_of_payment",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed disabled:text-gray-600",
                                        disabled: props.disableForm
                                    }, null, 8, _hoisted_77), [
                                        [_vModelText, formData.value.date_of_payment]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_78
                        ]),
                        _createTextVNode(),
                        (!props.disableForm)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createElementVNode("button", {
                                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                    onClick: _withModifiers(clearForm, ["prevent"])
                                }, "\n          Reset Form\n        "),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "ml-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                    onClick: _withModifiers(handleSave, ["prevent"])
                                }, "\n          Save\n        ")
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createTextVNode(),
                (showModal.value)
                    ? (_openBlock(), _createBlock(ModalWindow, {
                        key: 0,
                        onClose: closeModal
                    }, {
                        icon: _withCtx(() => [
                            _createVNode(_unref(CheckIcon), {
                                class: "h-6 w-6 text-green-600",
                                "aria-hidden": "true"
                            })
                        ]),
                        title: _withCtx(() => [
                            _createTextVNode("Confirm")
                        ]),
                        subtitle: _withCtx(() => [
                            (showUserSearch.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_80, "Please select a HROps user to approve the payments"))
                                : (_openBlock(), _createElementBlock("p", _hoisted_81, "No payments have been selected, this will now be sent on to Hire to Retire to confirm the leaver has been processed"))
                        ]),
                        footer: _withCtx(() => [
                            (showUserSearch.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _hoisted_83,
                                    _createTextVNode(),
                                    (!formData.value.HROpsAssignee?.email)
                                        ? (_openBlock(), _createBlock(UserSearch, {
                                            key: 0,
                                            group: "HROPS",
                                            onUpdatedUser: handleUser
                                        }))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                            _createElementVNode("input", {
                                                value: formData.value.HROpsAssignee.email,
                                                type: "email",
                                                name: "email",
                                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                                disabled: ""
                                            }, null, 8, _hoisted_85),
                                            _createTextVNode(),
                                            _createVNode(_unref(XIcon), {
                                                class: "text-gray-400 h-5 w-5 hover:text-gray-800 self-center ml-2 cursor-pointer",
                                                onClick: clearUser
                                            })
                                        ]))
                                ]))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                disabled: showUserSearch.value && !formData.value.HROpsAssignee?.email,
                                type: "button",
                                class: "mt-8 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500",
                                onClick: submitForm
                            }, "\n        Confirm\n      ", 8, _hoisted_86)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
